module.exports = __webpack_public_path__ + "img/zzh2.69b4ee43.jpg";